var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('span',{staticClass:"current"},[_vm._v(_vm._s(_vm.current))]),_c('span',[_vm._v("/")]),_c('span',{staticClass:"max"},[_vm._v(_vm._s(_vm.max))]),_c('span',{staticClass:"unit"},[_vm._v(_vm._s(_vm.unit))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f3d1036","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/current_max_progress.vue
// module id = null
// module chunks = 